import { ActivitySpinnerWidget } from '@tableau/widgets';
import React from 'react';

import { TinyEditorProps } from './TinyEditor';

// This needs to be exported so unit tests can find this React.lazy component
export const TinyEditor = React.lazy(() => import('./TinyEditor'));

/**
 * The async version of Tiny Editor so it's dependencies don't break
 * the login page for embedded browsers: TFS 978332
 */
export const LazyTinyEditor: React.FunctionComponent<TinyEditorProps> = props =>
  <React.Suspense fallback={spinner}>
    <TinyEditor
      id={props.id}
      formName={props.formName}
      editorConfig={props.editorConfig}
      value={props.value}
      changeHandler={props.changeHandler}
    />
  </React.Suspense>;

const spinner = <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
  <ActivitySpinnerWidget testId={'tiny-mce-spinner'} shouldShowUnderlay={false} />
</div>;
